<template>
	<div class="tests">
		<v-tabs
			vertical
			left
			color="primary"
			slider-color="primary"
			background-color="secondary"
			active-class="primary--text"
			style="border-radius: 4px"
			v-model="tabOpen"
		>
				<v-tab class="text-caption" v-translate href="#general">General</v-tab>
				<v-tab class="text-caption" v-translate href="#mtc" v-if="$store.getters.hasModule('mtc') || tcmTests.length > 0">TCM</v-tab>
				<v-tab class="text-caption" v-translate href="#osteo" v-if="$store.getters.hasModule('osteo') || osteoTests.length > 0">Osteopathy</v-tab>
				<v-tab class="text-caption" v-translate href="#custom" v-if="customTests.length > 0 && $store.getters.hasAnyModule">Custom</v-tab>
				<div style="height: 5px; background-color: white"></div>
				<v-btn class="text-caption primary--text" :disabled="cantEdit" text @click="getAppointments" :loading="loadingAppointmentsToImport">
					<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
					<translate>History</translate>
					<v-dialog v-model="showAppointmentsToImport" max-width="70%" scrollable>
						<v-card>
							<v-card-title class="title primary--text mb-2 secondary">
								<translate>Import Tests</translate>
							</v-card-title>
							<v-card-text class="pt-2">
								<p
									v-if="appointmentsToImport.length == 0"
									class="font-weight-thin ml-2"
									v-translate
								>No appointments.</p>
								<v-card v-else class="mx-auto mb-2" v-for="appointment in appointmentsToImport" :key="appointment.id">
									<v-list-item three-line>
										<v-list-item-content>
											<v-list-item-title class="primary--text">
												<v-row no-gutters class="text-body-1">
													<v-icon class="mr-1" small color="primary">mdi-account-tie</v-icon>
														<span class="mr-2">{{appointment.user.name}}</span>
													<v-icon class="mr-1" small color="primary">mdi-certificate</v-icon>
													<span>{{appointment.speciality.name}}</span>
													<v-spacer></v-spacer>
													<v-icon class="mr-1" small color="primary">mdi-calendar</v-icon>
														<span class="mr-2">{{appointment.date}}</span>
													<v-icon class="mr-1" small color="primary">mdi-clock-outline</v-icon>
													<span>{{appointment.time}}</span>
												</v-row>
											</v-list-item-title>
											<v-list-item-subtitle>{{appointment.description}}</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>
									<v-divider class="mx-4"></v-divider>
									<v-card-text>
										<ClinicHistoryTests @import-test="importTest" :loading="false" :appointment="appointment" :importOption="true" :loadingImportTest="loadingImportTest" />
									</v-card-text>
								</v-card>
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="primary darken-1" text @click="showAppointmentsToImport = false">
									<translate>Close</translate>
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-btn>
				<v-row style="background-color: white" no-gutters></v-row>
				<v-tab-item value="general" key="general" :transition="false" :reverse-transition="false">
					<v-container fluid>
						<v-expansion-panels multiple v-model="generalPanel">
							<v-expansion-panel key="vital-signs" v-if="$store.getters.hasAnyModule || vitalSignsTests.length > 0">
								<v-expansion-panel-header>
									<span>
										<v-icon v-if="vitalSignsTests.length > 0" color="primary" class="mr-3">check</v-icon>
										<strong>Sinais Vitais e Dados Antropométricos</strong>
									</span>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<p
										v-if="vitalSignsTests.length == 0"
										class="font-weight-thin ml-2"
										v-translate
									>No tests performed.</p>
									<v-list v-else flat>
										<v-list-item-group>
											<TestItem
												v-for="test in vitalSignsTests"
												:test="test"
												type="general"
												:key="test.id"
												@delete-test="deleteTest"
												@edit-test="editTest"
											/>
										</v-list-item-group>
									</v-list>
									<v-btn
										fab
										class="mb-3"
										color="primary"
										small
										@click="newGeneral = true"
										:disabled="!$store.getters.hasAnyModule"
									>
										<v-icon>mdi-plus</v-icon>
									</v-btn>
									<v-dialog v-model="newGeneral" max-width="1000" scrollable>
										<VitalSignsForm @create-test="createTest" @hide="newGeneral = false" />
									</v-dialog>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</v-container>
				</v-tab-item>
				<v-tab-item value="mtc" v-if="$store.getters.hasModule('mtc') || tcmTests.length > 0" key="mtc" :transition="false" :reverse-transition="false">
					<v-container fluid>
						<v-expansion-panels multiple v-model="mtcPanel">
							<v-expansion-panel key="tcm-body-structure" v-if="$store.getters.hasModule('mtc') || tcmBodyStructureTests.length > 0">
								<v-expansion-panel-header>
									<span>
										<v-icon v-if="tcmBodyStructureTests.length > 0" color="primary" class="mr-3">check</v-icon>
										<strong v-translate>Body Structure</strong>
									</span>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<p v-if="tcmBodyStructureTests.length == 0" class="font-weight-thin ml-2" v-translate>No tests performed.</p>
									<v-list v-else flat>
										<v-list-item-group>
											<TestItem
												v-for="test in tcmBodyStructureTests"
												:test="test"
												type="tcm"
												:key="test.id"
												@delete-test="deleteTest"
												@edit-test="editTest"
											/>
										</v-list-item-group>
									</v-list>
									<v-btn
										fab
										class="mb-3"
										color="primary"
										small
										@click="newBodyStructure = true"
										:disabled="!$store.getters.hasModule('mtc')"
									>
										<v-icon>mdi-plus</v-icon>
									</v-btn>
									<TCMBodyStructureForm v-if="newBodyStructure" @create-test="createTest" @hide="newBodyStructure = false" />
								</v-expansion-panel-content>
							</v-expansion-panel>
							<v-expansion-panel key="tcm-tongue" v-if="$store.getters.hasModule('mtc') || tcmTongueTests.length > 0">
								<v-expansion-panel-header>
									<span>
										<v-icon v-if="tcmTongueTests.length > 0" color="primary" class="mr-3">check</v-icon>
										<strong v-translate>Tongue</strong>
									</span>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<template v-if="tcmTongueTests.length == 0">
										<p class="font-weight-thin ml-2" v-translate>No tests performed.</p>
										<v-btn
											fab
											class="mb-3"
											color="primary"
											small
											@click="newTongue = true"
											:disabled="!$store.getters.hasModule('mtc') || tcmTongueTests.length > 0"
										>
											<v-icon>mdi-plus</v-icon>
										</v-btn>
										<TCMTongueForm v-if="newTongue" @create-test="createTest" @hide="newTongue = false" />
									</template>
									<template v-else>
										<TestItem
											v-for="test in tcmTongueTests"
											:test="test"
											type="tcm"
											:key="test.id"
											@delete-test="deleteTest"
											@edit-test="editTest"
										/>
									</template>
								</v-expansion-panel-content>
							</v-expansion-panel>
							<v-expansion-panel key="tcm-abdominal-palpation" v-if="$store.getters.hasModule('mtc') || tcmAbdominalPalpationTests.length > 0">
								<v-expansion-panel-header>
									<span>
										<v-icon v-if="tcmAbdominalPalpationTests.length > 0" color="primary" class="mr-3">check</v-icon>
										<strong v-translate>Abdominal Palpation</strong>
									</span>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<p v-if="tcmAbdominalPalpationTests.length == 0" class="font-weight-thin ml-2" v-translate>No tests performed.</p>
									<v-list v-else flat>
										<v-list-item-group>
											<TestItem
												v-for="test in tcmAbdominalPalpationTests"
												:test="test"
												type="tcm"
												:key="test.id"
												@delete-test="deleteTest"
												@edit-test="editTest"
											/>
										</v-list-item-group>
									</v-list>
									<v-btn
										fab
										class="mb-3"
										color="primary"
										small
										@click="newAbdominalPalpation = true"
										:disabled="!$store.getters.hasModule('mtc')"
									>
										<v-icon>mdi-plus</v-icon>
									</v-btn>
									<TCMAbdominalPalpationForm v-if="newAbdominalPalpation" @create-test="createTest" @hide="newAbdominalPalpation = false" />
								</v-expansion-panel-content>
							</v-expansion-panel>
							<v-expansion-panel key="tcm-pulse" v-if="$store.getters.hasModule('mtc') || tcmPulseTests.length > 0">
								<v-expansion-panel-header>
									<span>
										<v-icon v-if="tcmPulseTests.length > 0" color="primary" class="mr-3">check</v-icon>
										<strong v-translate>Pulse</strong>
									</span>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<p v-if="tcmPulseTests.length == 0" class="font-weight-thin ml-2" v-translate>No tests performed.</p>
									<v-list v-else flat>
										<v-list-item-group>
											<TestItem
												v-for="test in tcmPulseTests"
												:test="test"
												type="tcm"
												:key="test.id"
												@delete-test="deleteTest"
												@edit-test="editTest"
											/>
										</v-list-item-group>
									</v-list>
									<v-btn
										fab
										class="mb-3"
										color="primary"
										small
										@click="newPulse = true"
										:disabled="!$store.getters.hasModule('mtc')"
									>
										<v-icon>mdi-plus</v-icon>
									</v-btn>
									<TCMPulseForm v-if="newPulse" @create-test="createTest" @hide="newPulse = false" />
								</v-expansion-panel-content>
							</v-expansion-panel>
							<v-expansion-panel key="ryodoraku" v-if="$store.getters.hasModule('mtc') || ryodorakuTests.length > 0">
								<v-expansion-panel-header>
									<span>
										<v-icon v-if="ryodorakuTests.length > 0" color="primary" class="mr-3">check</v-icon>
										<strong>Ryodoraku</strong>
									</span>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<p
										v-if="ryodorakuTests.length == 0"
										class="font-weight-thin ml-2"
										v-translate
									>No tests performed.</p>
									<v-list v-else flat>
										<v-list-item-group>
											<TestItem
												v-for="test in ryodorakuTests"
												:test="test"
												type="ryodoraku"
												:key="test.id"
												@delete-test="deleteTest"
												@edit-test="editTest"
											/>
										</v-list-item-group>
									</v-list>
									<v-btn
										fab
										class="mb-3"
										color="primary"
										small
										@click="newRyodoraku = true"
										:disabled="!$store.getters.hasModule('mtc')"
									>
										<v-icon>mdi-plus</v-icon>
									</v-btn>
									<v-dialog v-model="newRyodoraku" max-width="80%" scrollable>
										<RyodorakuForm @create-test="createTest" @hide="newRyodoraku = false" />
									</v-dialog>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</v-container>
				</v-tab-item>
				<v-tab-item value="osteo" v-if="$store.getters.hasModule('osteo') || osteoTests.length > 0" key="osteo" :transition="false" :reverse-transition="false">
					<v-container fluid>
						<v-expansion-panels multiple v-model="osteoPanel">
							<v-expansion-panel key="osteo">
								<v-expansion-panel-header>
									<span>
										<v-icon v-if="osteoTests.length > 0" color="primary" class="mr-3">check</v-icon>
										<strong v-translate>Osteopathy</strong>
									</span>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<p v-if="osteoTests.length == 0" class="font-weight-thin ml-2" v-translate>No tests performed.</p>
									<v-list v-else flat>
										<TestItem
											v-for="test in osteoTests"
											:test="test"
											type="osteo"
											:key="test.id"
											@delete-test="deleteTest"
											@edit-test="editTest"
											:gender="patient.gender"
										/>
									</v-list>
									<v-btn
										fab
										class="mb-3"
										color="primary"
										small
										@click="osteoFormKey += 1; newOsteo = true"
										:disabled="!$store.getters.hasModule('osteo')"
									>
										<v-icon>mdi-plus</v-icon>
									</v-btn>
									<v-dialog v-model="newOsteo" max-width="95%" scrollable>
										<OsteopathyForm :key="osteoFormKey" @create-test="createTest" :gender="patient.gender" @hide="newOsteo = false" />
									</v-dialog>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</v-container>
				</v-tab-item>
				<v-tab-item value="custom" v-if="customTests.length > 0 && $store.getters.hasAnyModule" key="custom" :transition="false" :reverse-transition="false">
					<v-container fluid>
						<v-expansion-panels multiple v-model="customPanel">
							<v-expansion-panel v-for="customTest in customTests" :key="customTest.id">
								<v-expansion-panel-header>
									<span>
										<v-icon v-if="customTest.test" color="primary" class="mr-3">check</v-icon>
										<strong>{{customTest.name}}</strong>
									</span>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
										<p
											v-if="!customTest.test"
											class="font-weight-thin ml-2"
											v-translate
										>No tests performed.</p>
										<v-list v-else flat>
											<v-list-item-group>
												<TestItem
													:test="customTest.test"
													type="custom"
													:key="customTest.id"
													@delete-test="deleteCustomTest"
													@edit-test="editCustomTest"
												/>
											</v-list-item-group>
										</v-list>
										<v-btn
											fab
											class="mb-3"
											color="primary"
											small
											@click="customTest.show = true"
											:disabled="!$store.getters.hasAnyModule || customTest.test != null"
										>
											<v-icon>mdi-plus</v-icon>
										</v-btn>
										<v-btn
											v-if="$store.getters.hasPerm"
											fab
											class="mb-3 ml-2"
											color="primary"
											small
											@click="downloadPDF(customTest)"
											:disabled="!$store.getters.hasAnyModule"
											:loading="loadingPDF"
										>
											<v-icon>mdi-download</v-icon>
										</v-btn>
										<v-dialog v-model="customTest.show" max-width="1000" scrollable>
											<CustomTestForm @create-test="createCustomTest" @hide="customTest.show = false" :test="customTest" />
										</v-dialog>
										<VueHtml2pdf
											v-if="$store.getters.hasPerm"
											:show-layout="false"
											:float-layout="true"
											:enable-download="true"
											:paginate-elements-by-height="1000000"
											filename="test"
											:pdf-quality="2"
											pdf-format="a4"
											:ref="'html2Pdf' + customTest.id"
											:preview-modal="false"
											:html-to-pdf-options="{html2canvas: {useCORS: true}, pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }}"
											@hasDownloaded="loadingPDF = false"
											margin="100px"
										>
											<section slot="pdf-content">
												<v-app>
													<v-container fluid>
														<CustomTestForm :test="customTest" :pdfMode="true" />
													</v-container>
												</v-app>
											</section>
										</VueHtml2pdf>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</v-container>
				</v-tab-item>
		</v-tabs>
	</div>
</template>

<script>
import RyodorakuForm from "@/components/appointment/tests/ryodoraku/RyodorakuForm.vue";
import VitalSignsForm from "@/components/appointment/tests/general/VitalSignsForm.vue";
import OsteopathyForm from "@/components/appointment/tests/osteo/OsteopathyForm.vue";
import TestItem from "@/components/appointment/tests/TestItem.vue";
import TCMTongueForm from "@/components/appointment/tests/tcm/TCMTongueForm.vue";
import TCMPulseForm from "@/components/appointment/tests/tcm/TCMPulseForm.vue";
import TCMAbdominalPalpationForm from "@/components/appointment/tests/tcm/TCMAbdominalPalpationForm.vue";
import TCMBodyStructureForm from "@/components/appointment/tests/tcm/TCMBodyStructureForm.vue";
import CustomTestForm from "@/components/appointment/tests/custom/CustomTestForm.vue";
import ClinicHistoryTests from "@/components/patient/ClinicHistoryTests.vue";
import axios from "axios";
import { mapGetters } from 'vuex';
import VueHtml2pdf from 'vue-html2pdf';

export default {
	name: "Tests",
	props: ["tests", "customTests", "patient", "appointment"],
	components: {
		RyodorakuForm,
		VitalSignsForm,
		OsteopathyForm,
		TestItem,
		TCMTongueForm,
		TCMPulseForm,
		TCMAbdominalPalpationForm,
		TCMBodyStructureForm,
		CustomTestForm,
		ClinicHistoryTests,
		VueHtml2pdf
	},
	data: () => ({
		tabOpen: null,
		mtcPanel: [],
		osteoPanel: [],
		generalPanel: [],
		customPanel: [],
		newRyodoraku: false,
		newGeneral: false,
		newTongue: false,
		newPulse: false,
		newAbdominalPalpation: false,
		newBodyStructure: false,
		newOsteo: false,
		newCustom: false,
		osteoFormKey: 1,
		loadingAppointmentsToImport: false,
		showAppointmentsToImport: false,
		appointmentsToImport: [],
		loadingImportTest: false,
		loadingPDF: false
	}),
	computed: {
		ryodorakuTests() {
			return this.tests.filter(t => t.module == "ryodoraku");
		},
		tcmTests() {
			return this.tests.filter(t => t.module == "tcm");
		},
		tcmTongueTests() {
			return this.tests.filter(t => t.module == "tcm" && t.kind == 'tongue');
		},
		tcmPulseTests() {
			return this.tests.filter(t => t.module == "tcm" && t.kind == 'pulse');
		},
		tcmAbdominalPalpationTests() {
			return this.tests.filter(t => t.module == "tcm" && t.kind == 'abdominal-palpation');
		},
		tcmBodyStructureTests() {
			return this.tests.filter(t => t.module == "tcm" && t.kind == 'body-structure');
		},
		vitalSignsTests() {
			return this.tests.filter(t => t.module == "general");
		},
		osteoTests() {
			return this.tests.filter(t => t.module == "osteo");
		},
		...mapGetters({
      tourStep: 'tourStepEvent'
    }),
		cantEdit() {
			return !this.$store.getters.hasAnyModule;
		}
	},
	methods: {
		createTest(form) {
			console.log("ADD TEST");
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.pid;
			axios
				.post(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/exam/new",
					form
				)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
						if (response.data.result === "created") {
							this.tests.push(response.data.test);
						}
					}
				})
				.catch(error => console.log(error));
		},
		createCustomTest(test) {
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.pid;
			axios
				.post(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/custom-tests/new",
					test
				)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
						if (response.data.result === "created") {
							// for(let i=0; i < this.customTests.length; i++) {
							// 	if(this.customTests[i].id == response.data.test.id) this.customTests[i] = response.data.test;
							// }
							let currentTest = this.customTests.find(t => t.id === response.data.test.id);
              Object.assign(currentTest, response.data.test);
						}
					}
				})
				.catch(error => console.log(error));
		},
		editTest(test, form) {
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.pid;
			axios
				.post(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/exam/" +
						test.id +
						"/edit",
					form
				)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
						if (response.data.result === "edited") {
							this.tests.splice(this.tests.indexOf(test), 1);
							this.tests.push(response.data.test);
						}
					}
				})
				.catch(error => console.log(error));
		},
		editCustomTest(test) {
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.pid;
			axios
				.post(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/custom-tests/" +
						test.id +
						"/edit",
						test
				)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
					}
				})
				.catch(error => console.log(error));
		},
		deleteTest(test) {
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.aid;
			axios
				.post(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/exam/" +
						test.id +
						"/delete"
				)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
						if (response.data.result === "deleted") {
							this.tests.splice(this.tests.indexOf(test), 1);
						}
					}
				})
				.catch(error => console.log(error));
		},
		deleteCustomTest(test) {
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.pid;
			axios
				.post(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/custom-tests/" +
						test.id +
						"/delete"
				)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
						for(let i = 0; i < this.customTests.length; i++) {
							if(this.customTests[i].id == test.id) this.customTests[i].test = null;
						}
					}
				})
				.catch(error => console.log(error));
		},
		getAppointments() {
			this.loadingAppointmentsToImport = true;
			const patientId = this.$route.params.pid;
			const appointmentId = this.$route.params.aid;
			axios
				.get("/patient/" + patientId + "/appointment/" + appointmentId + "/import_options", {params: {tests: true}})
				.then(response => {
					console.log(response.data);
					if (response.status === 200) {
						this.appointmentsToImport = response.data.appointments;
						this.showAppointmentsToImport = true;
						this.loadingAppointmentsToImport = false;
					}
				})
				.catch(error => {
					console.log(error);
					this.loadingAppointmentsToImport = false;
				});
		},
		importTest(appointmentId, test, custom) {
			this.loadingImportTest = true;
			axios
				.post(`/patient/${this.appointment.patient_id}/appointment/${this.appointment.id}/import-test/${appointmentId}`, 
					null, 
					{params: {test: test, custom: custom ? true : false}}
				)
				.then(response => {
					console.log(response.data);
					this.loadingImportTest = false;
					if(response.data.result == "ok") {
						this.showAppointmentsToImport = false;
						if(custom) {
							let currentTest = this.customTests.find(t => t.id === response.data.test.id);
							Object.assign(currentTest, response.data.test);
						}
						else this.tests.push(response.data.test);
					}
				})
				.catch(error => {
					console.log(error);
					this.loadingImportTest = false;
				});
		},
		downloadPDF(test) {
			this.loadingPDF = true;
			setTimeout(() => {
				let ref = 'html2Pdf' + test.id;
				this.$refs[ref][0].generatePdf();
			}, 0);
		}
	},
	mounted() {
		let existCanvas = document.querySelector(".canvas");
		console.log(existCanvas);
		if(existCanvas) {
			existCanvas.remove();
		}
		if(this.osteoTests.length > 0) this.osteoPanel = [0];
		if(this.vitalSignsTests.length > 0) this.generalPanel = [0];
		if(this.tcmBodyStructureTests.length > 0) this.mtcPanel.push(0);
		if(this.tcmTongueTests.length > 0) this.mtcPanel.push(1);
		if(this.tcmAbdominalPalpationTests.length > 0) this.mtcPanel.push(2);
		if(this.tcmPulseTests.length > 0) this.mtcPanel.push(3);
		if(this.ryodorakuTests.length > 0) this.mtcPanel.push(4);
		for(let i = 0; i < this.customTests.length; i++) {
			this.$set(this.customTests[i], 'show', false);
		}
	},
	watch: {
		tourStep(value) {
			if(value == 'tour-test-vital-signs') {
				this.generalPanel = [0];
				this.newGeneral = true;
			}
			else if(value == 'tour-test-tongue') {
				this.tabOpen = 'mtc';
				this.mtcPanel = [1];
			}
			else if(value == 'tour-test-tongue-open') {
				this.newTongue = true;
			}
			else if(value == 'tour-test-osteo') {
				this.tabOpen = 'osteo';
				this.osteoPanel = [0];
			}
			else if(value == 'tour-test-osteo-open') {
				this.newOsteo = true;
			}
		}
	}
};
</script>

<style scoped>
.v-tab {
	justify-content: left !important;
	min-width: 240px;
}
</style>